import { LitElement, html } from 'lit-element';
import startOfDay from 'date-fns/esm/startOfDay';
import getTime from 'date-fns/esm/getTime';
import cellStyles from './styles/cell-styles';
import styles from './styles/styles';

export default class DatepickerCell extends LitElement {
  static get properties() {
    return {
      // parameter values that is set by user
      day: { type: Object },
      dateTo: { type: Number },
      dateFrom: { type: Number },
      month: { type: String },
      hoveredDate: { type: Number },
      minSelectableDate: { type: Number },
      maxSelectableDate: { type: Number },
      isCurrentDate: { type: Boolean },
      isPastDate: { type: Boolean },
      // local variables
      selected: { type: Boolean, attribute: false },
      hovered: { type: Boolean, attribute: false },
      disabled: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [styles, cellStyles];
  }

  updated(properties) {
    if (properties.has('dateFrom') || properties.has('dateTo') || properties.has('hoveredDate') || properties.has('day')) {
      this.dateChanged(this.dateFrom, this.dateTo, this.hoveredDate, this.day);
    }
  }

  // we used the function below because IE doesn't support Number.isNaN
  checkIsNaN(o) {
    return o !== o;
  }

  dateChanged(dateFrom, dateTo, hoveredDate, day) {
    this.selected = false;
    this.hovered = false;
    const parsedDateFrom = parseInt(dateFrom, 10);
    const parsedDateTo = parseInt(dateTo, 10);
    if (day) {
      if (getTime(startOfDay(parsedDateTo * 1000)) / 1000 === day.date
        || getTime(startOfDay(parsedDateFrom * 1000)) / 1000 === day.date) {
        this.selected = true;
      }
      if (
        (day.date <= hoveredDate
          && day.date > parsedDateFrom
          && !parsedDateTo
          && !this.checkIsNaN(parsedDateFrom)
          && parsedDateFrom !== undefined
          && !this.selected)
        || (day.date > parsedDateFrom && day.date < parsedDateTo)
      ) {
        this.hovered = true;
      }
    }
  }

  handleTap() {
    if (!this.disabled) {
      this.emitEvent('date-is-selected');
    }
  }

  handleHover() {
    this.emitEvent('date-is-hovered');
  }

  isSelected(selected) {
    return selected ? 'selected' : '';
  }

  isHovered(hovered) {
    return hovered ? 'hovered' : '';
  }

  isEnabled(day, minSelectableDate, maxSelectableDate) {
    this.disabled = false;
    if (day && (day.date === 0 || day.date) && (day.date < minSelectableDate || day.date > maxSelectableDate)) {
      this.disabled = true;
      return 'disabled';
    }
    return '';
  }

  emitEvent(eventType) {
    this.dispatchEvent(
      new CustomEvent(
        eventType, {
          detail: { date: this.day.date },
        },
      ),
    );
  }

  render() {
    return html`
      <div
        @click="${this.handleTap}"
        @mouseover="${this.handleHover}"
        id="day-cell"
        class="d-flex justify-content-center align-items-center text-center position-absolute rounded-2 day ${this.isPastDate ? 'pastDate' : ''}
                ${this.isCurrentDate ? 'currentDate' : ''} ${this.isSelected(this.selected)} ${this.isHovered(this.hovered)}
                ${this.isEnabled(this.day, this.minSelectableDate, this.maxSelectableDate)}" tabindex="0">
        <div class="d-flex justify-content-center align-items-center">
          ${this.day ? this.day.title : null}
        </div>
    </div>
`;
  }
}
